import React, { useState } from 'react'
import TextFieldUniversal from '../../../../../validate/form/text/TextFieldUniversal'

const SeriesInPackNumberTo = ({ required, setValidate, setValueForm, forciblyValue }) => {

	const [value, setValue] = useState('')

  return (
	<TextFieldUniversal
        value={value}
        setValue={e => {
            setValueForm(e)
            setValue(e)
        }}
        setValidate={setValidate}
        label={'№ товару в партії (кінець)'} 
        placeholder={'100'}
        validates={{
            isEmpty: true,
            isDigit: true,
        }}
        forciblyValue={forciblyValue}
        required={required}
    />
  )
}

export default SeriesInPackNumberTo